import { useNavigate } from "react-router-dom";
import useCreateNewSurvey from "src/hooks/useCreateNewSurvey";
import GenerateSurveyForm from "src/pages/generate-survey/generate-survey-form";
import ValidationStepsModal from "src/components/moderation-dialog/moderation-dialog";
import { useGetTemplatesQuery } from "src/redux/survey/template-endpoints";
import {
  GENERATION_INTERVAL,
  GENERATION_LOADING_STEPS,
  GENERATION_LOADING_TITLE,
  RETRYING_GENERATION_TITLE,
} from "src/pages/generate-survey/generate-survey.constants";
import useGenerateSurvey from "src/hooks/useGenerateSurvey";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/redux-store";
import { useMemo } from "react";
import { GenerateSurveyFormValues } from "src/pages/generate-survey/generate-survey.types";
import { SurveyTemplate } from "src/redux/survey/template.types";
import { useState } from "react";
import { useEffect } from "react";

const GenerateSurveyTab = () => {
  const navigate = useNavigate();
  const { createNewSurvey } = useCreateNewSurvey();
  const { generateSurvey, isGenerating, isRetrying } = useGenerateSurvey();
  const userState = useSelector((state: RootState) => state.userState);

  const {validationSteps, validationTitle} = useMemo(() => {
    const baseSteps = GENERATION_LOADING_STEPS;

    if (isRetrying) {
      baseSteps.unshift('Taking it from the top');
    }

    return { validationSteps: baseSteps, validationTitle: isRetrying ? RETRYING_GENERATION_TITLE : GENERATION_LOADING_TITLE };
  }, [isGenerating, isRetrying]);

  const urlParams = new URLSearchParams(window.location.search);
  const templateId = urlParams.get('template');

  const onBackClick = () => {
    navigate(templateId ? '/templates' : '/dashboard');
  };

  const onFormSubmission = (template_id: string, values: GenerateSurveyFormValues) => {
    void generateSurvey(template_id, values);
  };

  const { data: templatesData } = useGetTemplatesQuery(null);
  const [template, setTemplate] = useState<SurveyTemplate | null>(null);

  useEffect(() => {
    if (templatesData) {
      const allTemplates: SurveyTemplate[] = Object.values(templatesData).flat() as SurveyTemplate[];
      const foundTemplate = allTemplates.find(template => template.id === templateId);
      if (foundTemplate) {
        setTemplate(foundTemplate);
      } else {
        const defaultTemplate = allTemplates.find(template => template.category === "DEFAULT");
        setTemplate(defaultTemplate || null);
      }
    }
  }, [templatesData, templateId]);

  return (
    <div className="flex items-center justify-center gap-4 w-full">
      <div className="flex-column flex justify-center p-0 md:p-6">
        <div className="flex flex-row sm-max:flex-col items-start gap-4">
          <div className="flex flex-col items-center justify-start pl-4 md:pl-8 pr-10 md:pr-20 rounded-t-2xl md:rounded-2xl bg-white md:shadow-md pb-8">
            <GenerateSurveyForm
              isLoading={false}
              onSubmit={onFormSubmission}
              template={template}
            />
          </div>
        </div>
      </div>
      <ValidationStepsModal
        isModalOpen={isGenerating}
        handleCloseModal={() => {}}
        showFooter={false}
        steps={validationSteps}
        title={validationTitle}
        updateInterval={GENERATION_INTERVAL}
        windowSize={6}
      />
    </div>
  );
};

export default GenerateSurveyTab;
